import React from 'react';
import { Navigate } from 'react-router-dom';
import { adminSessionStorage } from '@/lib/sessionAuth';
interface ProtectedRouteProps {
  children: React.ReactNode;
}
/**
 * High-order component to protect administrative routes.
 * Checks for the presence of 'admin_token' in localStorage.
 */
export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const token = adminSessionStorage.getToken();
  if (!token) {
    // Redirect to login if not authenticated
    return <Navigate to="/admin/login" replace />;
  }
  return <>{children}</>;
};
